import {
    Container,
    Grid,
    Typography,
    Paper,
    TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import globals from "../globals";
import { styled } from "@mui/system";
import TextFieldRedBackground from "../components/text_filed_red_background";
import RedButton from "../components/redButton";
import FileUploadList from "../components/file_upload_list";

const DashboardTextField = styled(TextField)(() => ({
    '& .MuiOutlinedInput-root': {
        borderRadius: 5,
        backgroundColor: globals.colors.lightPink,
        '& .MuiInputBase-input': {
            backgroundColor: 'transparent',
        },
        '& .MuiInputBase-inputMultiline': {
            backgroundColor: 'transparent',
        },
        '& fieldset': {
            borderRadius: 5,
            borderColor: 'transparent', // no border by default
        },
        '&:hover fieldset': {
            borderColor: 'transparent', // no border on hover
        },
        '&.Mui-focused fieldset': {
            borderColor: globals.colors.lightRed, // red border when typing
        },
    },
}));

const initialInstructorData = {
    first_name: '',
    last_name: '',
    phone_number: '',
    email: '',
    motivation_description: '',
    subjects_description: '',
    education_description: '',
};

const InstructorForm = () => {
    const navigate = useNavigate();

    const [instructorData, setInstructorData] = useState(initialInstructorData);

    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [hasFileError, setHasFileError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formRenderKey, setFormRenderKey] = useState(0);

    function handleAddFiles(selectedFiles) {
        setUploadedFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
        setHasFileError(false);
    }

    function handleRemoveFile(indexToRemove) {
        setUploadedFiles((prevFiles) => {
            const updatedFiles = prevFiles.filter((_, index) => index !== indexToRemove);
            if (!updatedFiles.length) setHasFileError(true);
            return updatedFiles;
        });
    }

    function handleSubmit(event) {
        if (loading) return;

        if (!uploadedFiles.length) {
            event.preventDefault();
            setHasFileError(true);
            return;
        }

        event.preventDefault();
        setLoading(true);

        const data = {
            first_name: instructorData.first_name,
            last_name: instructorData.last_name,
            phone_number: instructorData.phone_number,
            email: instructorData.email,
            motivation_description: instructorData.motivation_description,
            subjects_description: instructorData.subjects_description,
            education_description: instructorData.education_description
        }

        const formData = new FormData();
        formData.append('data', JSON.stringify(data));
        for(const f of uploadedFiles){
            formData.append('documents', f)
        }

        fetch(
            `${globals.apiUrl}/instructor-form/create`,
            {
                method: 'POST',
                body: formData
            },
        ).then(response => response.json()).then(data => {
            if (data.detail){
                console.log(data.detail)
                return;
            }
            console.log(data)
            setInstructorData(initialInstructorData);
            setUploadedFiles([]);
            setHasFileError(false);
            setFormRenderKey((prev) => prev + 1);
            navigate('/success-form');
        }).catch(error => {
            console.error('Error:', error)
        }).finally(() => {
            setLoading(false);
        });
    }

    const handleChangeInstructorData = (event) => {
        setInstructorData({
            ...instructorData,
            [event.target.id]: event.target.value
        });
        console.log(instructorData)
    };

    return (
        <Container maxWidth="md" sx={{ py: { xs: 3, sm: 5 } }}>
            <Grid
                container
                justifyContent="center"
                textAlign="center"
                alignItems="center"
                alignContent="center"
                spacing={2}
            >
                <Grid item xs={12}>
                    <img src="new_instructor.png" style={{ height: 200, width: "auto" }} />
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={{ color: globals.colors.lightRed, fontWeight: "bold", fontSize: 30 }}>
                        Стани онлайн учител
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={{ mt: 1 }}>
                    <Typography sx={{ color: globals.colors.darkBlue, fontWeight: "bold", fontSize: 16 }}>
                        Попълни формата с коректни данни и ние ще се свържем с теб!
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Paper
                        elevation={6}
                        sx={{
                            mx: "auto",
                            maxWidth: { xs: "100%", sm: "100%" },
                            p: { xs: 2, sm: 3 },
                            borderRadius: 3,
                        }}
                    >
                        <Grid
                            key={formRenderKey}
                            component="form"
                            container
                            spacing={2}
                            justifyContent="center"
                            textAlign="left"
                            onSubmit={handleSubmit}
                        >
                            <Grid item xs={12}>
                                <Typography sx={{ ml: 1, fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 14 }} >Имe*</Typography>
                                <TextFieldRedBackground idName="first_name" onChange={handleChangeInstructorData} inputProps={{ pattern: "[A-Za-z А-Яа-я]+" }} helperText={"Името може да съдържа само малки и главни букви."} />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography sx={{ ml: 1, fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 14 }} >Фамилия*</Typography>
                                <TextFieldRedBackground idName="last_name" onChange={handleChangeInstructorData} inputProps={{ pattern: "[A-Za-z А-Яа-я]+" }} helperText={"Фамилията може да съдържа само малки и главни букви."} />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography sx={{ ml: 1, fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 14 }} >Имейл*</Typography>
                                <TextFieldRedBackground idName='email' onChange={handleChangeInstructorData} inputProps={{ type: 'email' }} helperText={"Моля, въведете валиден имейл адрес."} />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography sx={{ ml: 1, fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 14 }} >Телефон*</Typography>
                                <TextFieldRedBackground labelName={'+359'} onChange={handleChangeInstructorData} idName={'phone_number'} inputProps={{ pattern: '[+]?[0-9]{10,13}' }} helperText={'Моля, въведете валиден телефонен номер.'} />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography sx={{ ml: 1, fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 14 }} >Защо искате да сте учител в eAcademiaBg?*</Typography>
                                <DashboardTextField id={'motivation_description'} onChange={handleChangeInstructorData} required rows={5} multiline fullWidth />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography sx={{ ml: 1, fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 14 }} >Какъв/какви предмет/и преподавате?*</Typography>
                                <DashboardTextField id={'subjects_description'} onChange={handleChangeInstructorData} required rows={5} multiline fullWidth />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography sx={{ ml: 1, fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 14 }} >Какво образование имате?*</Typography>
                                <DashboardTextField id={'education_description'} onChange={handleChangeInstructorData} required rows={5} multiline fullWidth />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography sx={{ fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 14, mb: 1 }} >
                                    Прикачете файл (CV, диплома или друг документ)*
                                </Typography>
                                <FileUploadList
                                    files={uploadedFiles}
                                    onAdd={handleAddFiles}
                                    onRemove={handleRemoveFile}
                                    getFileKey={(file, index) => `${file.name}-${file.lastModified}-${index}`}
                                    error={hasFileError}
                                    helperText={
                                        uploadedFiles.length
                                            ? `Избрани файлове: ${uploadedFiles.length}`
                                            : "Моля, прикачете поне един файл."
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", pt: 1 }}>
                                <RedButton
                                    text={loading ? "Изпращане..." : "Изпрати"}
                                    disabled={!uploadedFiles.length || loading}
                                    loading={loading}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    )
}

export default InstructorForm